import {h, Fragment} from "preact"
import { useEffect, useState } from 'preact/hooks'

export default function CollectionLayout({ defaultDesktopLayout = 'large' }) {
    const [mobileLayout, setMobileLayout] = useState('large')
    const [desktopLayout, setDesktopLayout] = useState(defaultDesktopLayout)

    useEffect(() => {
        // Load saved preferences on component mount
        const savedMobileLayout = localStorage.getItem('collection-mobile-layout') || 'large'
        const savedDesktopLayout = localStorage.getItem('collection-desktop-layout') || defaultDesktopLayout

        setMobileLayout(savedMobileLayout)
        setDesktopLayout(savedDesktopLayout)

        // Apply saved layouts to DOM
        applyLayout('mobile', savedMobileLayout)
        applyLayout('desktop', savedDesktopLayout)
    }, [])

    const applyLayout = (device, layout) => {
        const productList = document.getElementById('product-list-template--25089175781725__main')
        if (productList) {
            if (device === 'mobile') {
                productList.setAttribute('collection-mobile-layout', layout)
            } else if (device === 'desktop') {
                productList.setAttribute('collection-desktop-layout', layout)
            }
        }
    }

    const changeLayout = (device, layout) => {
        // Save to localStorage
        localStorage.setItem(`collection-${device}-layout`, layout)

        // Update state
        if (device === 'mobile') {
            setMobileLayout(layout)
        } else if (device === 'desktop') {
            setDesktopLayout(layout)
        }

        // Apply to DOM
        applyLayout(device, layout)
    }

    const renderLayoutSwitch = (device) => {
        const layouts = [
            { value: 'large', label: 'Switch to larger product images', svgPath: 'M0 0h18v18H0z' },
            {
                value: 'medium',
                label: 'Switch to smaller product images',
                svgPath: 'M0 0h8v8H0zM0 10h8v8H0zM10 0h8v8h-8zM10 10h8v8h-8z',
            },
            ...(device === 'desktop'
                ? [
                      {
                          value: 'compact',
                          label: 'Switch to compact product images',
                          svgPath: 'M0 0h18v2H0zm0 4h18v2H0zm0 4h18v2H0zm0 4h18v2H0zm0 4h18v2H0z',
                      },
                  ]
                : []),
        ]

        const currentLayout = device === 'mobile' ? mobileLayout : desktopLayout

        return (
            <collection-layout-switch
                device={device}
                class={`collection-toolbar__layout-switch-list ${device === 'mobile' ? 'sm:hidden' : 'sm-max:hidden'}`}
                aria-controls='product-list-template--25089175781725__main'>
                {layouts.map((layout) => (
                    <button
                        key={layout.value}
                        type='button'
                        value={layout.value}
                        class={`collection-toolbar__button ${layout.value === currentLayout ? 'is-active' : ''}`}
                        aria-label={layout.label}
                        onClick={() => changeLayout(device, layout.value)}>
                        <svg role='presentation' width='18' viewBox='0 0 18 18' fill='none'>
                            <path fill='currentColor' d={layout.svgPath}></path>
                        </svg>
                    </button>
                ))}
            </collection-layout-switch>
        )
    }

    return (
        <>
            {renderLayoutSwitch('mobile')}
            {renderLayoutSwitch('desktop')}
        </>
    )
}
